// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const beldum: PokeData = {
  "id": 374,
  "name": "beldum",
  "height": 6,
  "weight": 952,
  "base_experience": 60,
  "types": [
    PokeType.STEEL,
    PokeType.PSYCHIC
  ],
  "api_moves": [
    "tackle",
    "take-down"
  ],
  "moves": [
    "tackle",
    "metal-claw",
    "psychic-terrain",
    "metal-sound",
    "prismatic-cage",
    "calm-mind",
    "meteor-mash",
    "future-sight",
    "magnet-pull",
    "healing-wish",
    "zen-headbutt",
    "iron-defense",
    "psychic"
  ],
  "evolution_chain": {
    "id": 192,
    "item": null,
    "species": [
      {
        "name": "beldum",
        "order": 404,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "metang",
        "order": 405,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 374,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 20,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "metagross",
        "order": 406,
        "types": [
          PokeType.STEEL,
          PokeType.PSYCHIC
        ],
        "evolves_from_species_id": 375,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 45,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 55,
    "speed": 30,
    "ability_power": 55
  },
  "stat_changes": [],
  "catch_rate": 3,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
